<template>
  <div class="view-content">
    <!-- <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="用户名称:" prop="searchName">
          <el-input
            v-model="search.searchName"
            placeholder="用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="clearSearch" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <el-row :gutter="20">
      <!-- 左侧：角色列表 -->
      <el-col :span="10">
        <div class="tools-box">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="handleAddRole"
            >新增角色</el-button
          >
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          size="small"
          :header-cell-style="{
            background: '#98b8d9',
            color: '#ffffff',
            fontWeight: 'bold',
            align: 'center',
          }"
        >
          <el-table-column prop="roleName" label="角色名称"> </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status == 1">
                正常
              </el-tag>
              <el-tag type="success" v-if="scope.row.status == 0">
                禁用
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                class="el-icon-edit table-btn btn-default"
                @click="handleEdit(scope.row)"
              >
                编辑
              </span>
              <span
                class="el-icon-setting table-btn btn-success"
                @click="handlePermissions(scope.row)"
              >
                配置权限
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            :current-page.sync="search.pageIndex"
            :page-size.sync="search.pageSize"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </el-col>
      <el-col :span="14">
        <div v-if="currentRoleId" class="permission-config">
          <div class="config-header">
            <div>
              <span style="font-weight: bold">{{ currentRoleName }}</span>
              <span style="margin-left: 10px; font-size: 12px; color: #909399">
                正在配置权限
              </span>
            </div>
            <div>
              <el-button
                type="primary"
                @click="handleSavePermissions"
                :loading="saving"
                size="small"
              >
                保存权限
              </el-button>
              <el-button @click="handleReset" size="small"> 重置 </el-button>
            </div>
          </div>
          <!-- -->
          <el-tabs v-model="activeTab" type="border-card">
            <!-- 页面权限标签页 -->
            <el-tab-pane label="页面访问权限" name="page">
              <div class="permission-tip">
                <i class="el-icon-info"></i>
                勾选角色可以访问的页面，子页面被勾选时父级会自动勾选
              </div>
              <el-tree
                v-if="pageTreeData.length > 0"
                ref="pageTree"
                :data="pageTreeData"
                show-checkbox
                node-key="id"
                :props="treeProps"
                :default-checked-keys="checkedPageKeys"
                :expand-on-click-node="false"
                @check="handlePageCheck"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i :class="data.icon"></i>
                  <span>{{ node.label }}</span>
                  <!-- <span class="permission-code">{{ data.permission }}</span> -->
                </span>
              </el-tree>
              <div v-else class="loading-placeholder">
                <el-skeleton :rows="5" animated />
              </div>
            </el-tab-pane>

            <!-- 按钮权限标签页 -->
            <el-tab-pane label="按钮操作权限" name="button">
              <div class="permission-tip">
                <i class="el-icon-info"></i>
                配置角色在页面中可以操作的按钮，只有勾选了页面权限才能配置该页面的按钮权限
              </div>

              <div v-if="availablePages.length === 0" class="empty-buttons">
                <el-empty
                  description="请先在「页面访问权限」中勾选页面，再配置按钮权限"
                />
              </div>

              <div v-else class="button-permission-list">
                <el-collapse v-model="activeCollapse">
                  <el-collapse-item
                    v-for="page in availablePages"
                    :key="page.id"
                    :name="page.id"
                  >
                    <template slot="title">
                      <div class="collapse-title">
                        <i :class="page.icon" style="margin-right: 8px"></i>
                        <span>{{ page.name }}</span>
                        <span class="page-path">{{ page.path }}</span>
                        <!-- <span class="page-permission">{{ page.permission }}</span> -->
                      </div>
                    </template>

                    <div class="button-group">
                      <el-checkbox-group
                        v-model="page.checkedButtons"
                        @change="handleButtonChange(page)"
                      >
                        <el-checkbox
                          v-for="button in page.buttons"
                          :key="button.id"
                          :label="button.id"
                        >
                          <i :class="button.icon"></i>
                          {{ button.name }}
                          <!-- <span class="button-code">{{ button.code }}</span> -->
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="roleForm.id ? '编辑角色' : '添加角色'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="roleForm"
        :model="roleForm"
        label-width="110px"
        size="small"
        :rules="rules"
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="roleForm.status" style="width: 100%">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">正常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="handleClose"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="handleConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { roleList, roleAdd, roleSet } from "@/api/system/role";
import axios from "axios";
export default {
  name: "RoleManagement",
  data() {
    return {
      search: {
        searchName: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      roleForm: {
        roleName: "",
        status: 1,
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      // 角色列表
      roleList: [],
      activeTab: "page",
      activeCollapse: [],
      saving: false,
      metaLoading: false,

      // 权限元数据
      permissionMeta: null,
      pageTreeData: [],

      // 角色相关
      roleList: [],
      currentRoleId: "",
      currentRoleName: "",
      currentRolePermissions: null,

      // 树形配置
      treeProps: {
        children: "children",
        label: "name",
      },

      // 页面权限数据
      checkedPageKeys: [],
      originalCheckedPageKeys: [],

      // 按钮权限数据
      availablePages: [],
      originalButtonPermissions: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      await this.loadPermissionMeta();
      await this.getTableData();
      if (this.tableData.length > 0) {
        this.currentRoleId = this.tableData[0].id;
        this.currentRoleName = this.tableData[0].roleName;
        await this.loadRolePermissions(this.tableData[0]);
      }
    },
    // 选择角色
    async selectRole(roleId) {
      this.currentRoleId = roleId;
    },
    // 加载角色权限
    async loadRolePermissions(data) {
      const permissions = {
        pages: data.menuIdslist,
        buttons: data.buttonIdslist,
      };
      this.currentRolePermissions = permissions;
      console.log(
        "加载角色权限，页面权限:",
        permissions,
        "按钮权限:",
        permissions.buttons,
      );
      // 设置页面权限
      this.checkedPageKeys = permissions.pages;
      console.log("设置页面权限，当前勾选的页面:", permissions.pages);
      this.originalCheckedPageKeys = [...permissions.pages];

      // 设置按钮权限
      this.availablePages = this.getAvailablePages(this.checkedPageKeys);
      this.availablePages.forEach((page) => {
        page.checkedButtons = permissions.buttons.filter((btn) =>
          page.buttons.some((b) => b.id === btn),
        );
      });
      this.originalButtonPermissions = JSON.parse(
        JSON.stringify(this.availablePages),
      );

      // 默认展开所有折叠面板
      this.activeCollapse = this.availablePages.map((p) => p.id);

      // 更新树形控件的勾选状态
      this.$nextTick(() => {
        if (this.$refs.pageTree) {
          this.$refs.pageTree.setCheckedKeys(this.checkedPageKeys);
        }
      });
    },
    // 获取所有可用的页面（用于按钮配置）
    getAvailablePages(checkedPageKeys) {
      const pages = [];
      const collectPages = (data) => {
        data.forEach((item) => {
          if (
            checkedPageKeys.includes(item.id) &&
            item.buttons &&
            item.buttons.length > 0
          ) {
            pages.push({
              id: item.id,
              name: item.name,
              icon: item.icon,
              path: item.path,
              permission: item.permission,
              buttons: item.buttons,
              checkedButtons: [],
            });
          }
          if (item.children && item.children.length) {
            collectPages(item.children);
          }
        });
      };
      collectPages(this.pageTreeData);
      return pages;
    },
    // 加载权限元数据
    async loadPermissionMeta() {
      this.metaLoading = true;
      try {
        // 从 public 目录读取 JSON 文件
        const response = await axios.get("/permission-meta.json");
        this.permissionMeta = response.data;
        this.pageTreeData = this.permissionMeta.permissions || [];
      } catch (error) {
        this.$message.error("加载权限元数据失败，请检查文件是否存在");
      } finally {
        this.metaLoading = false;
      }
    },

    // 保存权限
    async handleSavePermissions() {
      this.saving = true;

      // 获取选中的页面权限
      const checkedPages = this.$refs.pageTree.getCheckedKeys();

      // 获取选中的按钮权限
      const checkedButtons = [];
      this.availablePages.forEach((page) => {
        checkedButtons.push(...page.checkedButtons);
      });

      // 构建保存数据
      const saveData = {
        roleId: this.currentRoleId,
        // roleName: this.currentRoleName,
        menuIds: checkedPages,
        buttonIds: checkedButtons,
      };
      console.log(saveData, "saveData");
      roleSet(saveData).then((res) => {
        if (res.data.isSuccess) {
          this.saving = false;

          // 更新原始数据
          this.originalCheckedPageKeys = [...checkedPages];
          this.originalButtonPermissions = JSON.parse(
            JSON.stringify(this.availablePages),
          );
          this.getTableData();
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 重置
    handleReset() {
      this.$confirm("确定要重置吗？未保存的修改将丢失。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 重置页面权限
          this.checkedPageKeys = [...this.originalCheckedPageKeys];
          this.$refs.pageTree.setCheckedKeys(this.checkedPageKeys);
          // 重置按钮权限
          this.availablePages = JSON.parse(
            JSON.stringify(this.originalButtonPermissions),
          );
          this.activeCollapse = this.availablePages.map((p) => p.id);

          this.$message.info("已重置");
        })
        .catch(() => {});
    },
    // 页面权限勾选
    handlePageCheck() {
      const checkedKeys = this.$refs.pageTree.getCheckedKeys();
      // 更新可用的页面列表（用于按钮配置）
      this.availablePages = this.getAvailablePages(checkedKeys);
      // 保留已勾选的按钮
      this.availablePages.forEach((page) => {
        const original = this.originalButtonPermissions.find(
          (ob) => ob.id === page.id,
        );
        if (original) {
          page.checkedButtons = original.checkedButtons.filter((btn) =>
            page.buttons.some((b) => b.id === btn),
          );
        }
      });
      // 更新折叠面板
      this.activeCollapse = this.availablePages.map((p) => p.id);
    },

    //配置权限
    async handlePermissions(row) {
      this.currentRoleId = row.id;
      this.currentRoleName = row.roleName;
      await this.loadRolePermissions(row);
    },

    // 按钮权限改变
    handleButtonChange(page) {
      console.log("页面及按钮", this.availablePages);
      console.log("按钮权限改变:", page.name, page.checkedButtons);
    },

    async getTableData() {
      await roleList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          console.log(this.tableData);
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.roleForm = row;
    },
    handleSearch() {
      this.search.pageIndex = 1;
      this.getTableData();
    },
    clearSearch() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleAddRole() {
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.roleForm.validate((valid) => {
        if (!valid) return;
        roleAdd(this.roleForm).then((res) => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
            this.dialogVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.permission-tip {
  color: #f92626;
  font-size: small;
}

/* 权限配置样式 */
.permission-config {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.config-header {
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.permission-tip {
  padding: 10px 15px;
  background-color: #ecf5ff;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 12px;
  color: #409eff;
}

.permission-tip i {
  margin-right: 5px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-tree-node i {
  font-size: 16px;
}

.permission-code {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

.loading-placeholder {
  padding: 20px;
}

/* 按钮权限样式 */
.button-permission-list {
  padding: 10px;
}

.collapse-title {
  display: flex;
  align-items: center;
  flex: 1;
}

.page-path {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

.page-permission {
  margin-left: 10px;
  font-size: 11px;
  color: #67c23a;
  background-color: #f0f9ff;
  padding: 2px 6px;
  border-radius: 3px;
}

.button-group {
  padding: 15px;
  background-color: #fafafa;
}

.button-code {
  margin-left: 8px;
  font-size: 12px;
  color: #909399;
}

.empty-buttons {
  padding: 40px;
}

/* 预览样式 */
.preview-container {
  padding: 20px;
}

.preview-section {
  margin-bottom: 30px;
}

.preview-section h4 {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.preview-tags {
  display: flex;
  flex-wrap: wrap;
}

.preview-code {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
}

.preview-code pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 12px;
  color: #303133;
}

.no-role-selected {
  padding: 80px 20px;
  text-align: center;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
}

.el-checkbox {
  margin-right: 20px;
  margin-bottom: 10px;
}

.el-dialog__wrapper /deep/ .el-dialog {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
}

.el-dialog__wrapper /deep/ .el-dialog__header {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
  background: #409eff;
  padding: 10px 20px 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__title {
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.el-dialog__wrapper /deep/ .el-dialog__headerbtn {
  top: 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__wrapper /deep/ .el-dialog__close {
  color: #ffffff;
}

.el-dialog__wrapper /deep/ .el-dialog__footer {
  border-top: 1px solid #e8eaec;
  padding: 10px !important;
}

.el-button--primary {
  background: #409eff;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 15px;
  max-height: 550px;
  overflow: auto;
}
</style>
